import React from 'react'
import { storiesOf } from '@storybook/react'

import Paper from 'components/Paper'
import Typography from '@material-ui/core/Typography'

storiesOf('Essentials/Typography', module)
  .add('variants', () => (
    <div>
      (Correspondig Figma naming in parenthesis)

      <Paper elevation={0}>
        <Typography variant="body2" gutterBottom>
          Body 2
        </Typography>
        <Typography variant="body1" gutterBottom>
          Body 1 ("Body Medium")
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Subtitle1 ("Descriptor")
        </Typography>
        <Typography variant="h5" gutterBottom>
          H5 ("Heading 1")
        </Typography>
        <Typography variant="h6" gutterBottom>
          H6 ("Heading 2")
        </Typography>
        <Typography variant="h4" gutterBottom>
          H4 ("Large Number")
        </Typography>
        <Typography variant="caption" gutterBottom>
          Caption ("Small Label")
        </Typography>
        <Typography variant="h3" gutterBottom>
          H3 ("Small Label Light")
        </Typography>
        <Typography gutterBottom noWrap>
          {`
            Default copy -
            Lorem ipsum dolor sit amet, consectetur adipisicing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          `}
        </Typography>
        <Typography variant="button" gutterBottom>
          Button
        </Typography>
      </Paper>
      <Paper elevation={0} color="accent">
        <Typography variant="body2" gutterBottom color="inherit">
          Body 2
        </Typography>
        <Typography variant="body1" gutterBottom color="inherit">
          Body 1 ("Body Medium")
        </Typography>
        <Typography variant="subtitle1" gutterBottom color="inherit">
          Subtitle1 ("Descriptor")
        </Typography>
        <Typography variant="h5" gutterBottom color="inherit">
          H5 ("Heading 1")
        </Typography>
        <Typography variant="h6" gutterBottom color="inherit">
          H6 ("Heading 2")
        </Typography>
        <Typography variant="h4" gutterBottom color="inherit">
          H4 ("Large Number")
        </Typography>
        <Typography variant="caption" gutterBottom color="inherit">
          Caption ("Small Label")
        </Typography>
        <Typography variant="h2" gutterBottom>
          H2 ("Small Label Light")
        </Typography>
        <Typography gutterBottom noWrap color="inherit">
          {`
            Default copy -
            Lorem ipsum dolor sit amet, consectetur adipisicing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          `}
        </Typography>
        <Typography variant="button" gutterBottom color="inherit">
          Button
          </Typography>
      </Paper>
    </div>
  ))
